import { AttachingFile } from "../interfaces/IGraduateFilterObjMsg";
import { IPreSignedUrlReq, IPresignedUrl } from "../interfaces/IPreSignedUrl";
import { getSignUrl, uploadFileSignedUrl } from "./s3Service";
import jwt from 'jsonwebtoken';

type MailTemplateFile = {name:string, url:string} | null

export enum LastTemplateType {
    GRADUATE,COMPANY
}

export type LastTemplateModel = {
    body: string
    type:LastTemplateType
    subject: string
    attachments: Array<AttachingFile>
}

export const uploadLastMailTemplate = async(template: LastTemplateModel) =>{
    const mailTemplate:MailTemplateFile = await getLastTemplate(template.type);
    if(mailTemplate){
        const file = new File([JSON.stringify(template)], mailTemplate.name, { type: "text/plain" });
        let results = new FormData();
        results.append('file', file, mailTemplate.name);

        await uploadFileSignedUrl(mailTemplate.url, file);
    }
}

export const loadLastTemplate = async(type:LastTemplateType):Promise<LastTemplateModel | null> =>{
    const signature:MailTemplateFile = await getLastTemplate(type,"GET");
    if(signature){
        
        const response:Response = await fetch(signature.url);
        if (!response.ok) {
            return {
                body: "",
                attachments: [],
                subject: "",
                type:type
            }
        }
        const stringTemplate:string = await response.text()
        try {
            return JSON.parse(stringTemplate);
        } catch (e) {
            return {
                body: stringTemplate,
                attachments: [],
                subject: "",
                type:type
            }
        }
    }
    return null;
   }

export const getLastTemplate = async(type:LastTemplateType, method:string="POST"):Promise<MailTemplateFile> =>{
    if (sessionStorage.getItem('Bearer')) {
        const itemProfile = sessionStorage.getItem('Bearer') ? sessionStorage.getItem('Bearer') + "" : "";
        if (jwt.decode(itemProfile)) {
            const resDecoded: any = jwt.decode(itemProfile);
            if (resDecoded) {
                const profileDecoded: any = resDecoded.message;
                const fileName: string = `template_${profileDecoded.id}_${profileDecoded.username}_${type}.txt`;            
                const fileToUpload: IPreSignedUrlReq = {
                    contentType: "text/plain",
                    fileKey: fileName,
                    folderId: `mailTemplates`,
                    description: "",
                    isPublic: false,
                  }
                const resultURL: IPresignedUrl = await getSignUrl(fileToUpload, method);
                if (resultURL) {
                    return {
                        name: fileName,
                        url: resultURL.uploadURL
                    };
                }
                return null;
            }
        }
    }
    return null;
}